module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1531-f5a905271c9fde262e42f55b751055c0.png";